import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const TableAnimation = () => {
  const containers = document.querySelectorAll(".table-module");
  if (containers.length < 1) {
    return;
  }

  const reduceMotion = window.matchMedia(
    "(prefers-reduced-motion: reduce)",
  ).matches;
  if (reduceMotion) return;

  const base = {
    y: 0,
    opacity: 1,
    duration: 1,
    ease: "power2.inOut",
  };
  const applyAnimations = () => {
    containers.forEach((container) => {
      const headline = container.querySelectorAll(".table-module__headline");
      const table = container.querySelectorAll(".table-module__content");

      if (!headline.length && !table.length) return;

      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: container,
          start: "top 80%",
          once: true,
          fastScrollEnd: true,
        },
      });

      if (headline.length) {
        tl.to(headline, { ...base, x: 0 });
      }

      if (table.length) {
        tl.to(table, {
          opacity: 1,
          duration: 1,
          ease: "back.out(1.7, 0.5)",
          scale: 1,
        });
      }
    });
  };
  applyAnimations();
};

export default TableAnimation;
